<template>
  <brows-layout
    @edit="$emit('edit')"
    @next="$emit('next')"
    class="pdf color-text2"
  >
    <el-form label-position="left" label-width="140px">
      <el-form-item label="故事名稱">
        <p class="color-danger" v-if="!editStoryData.story_name">尚未填寫</p>
        <p class="color-black" v-else>{{ editStoryData.story_name }}</p>
      </el-form-item>
      <el-form-item label="DFC 挑戰學習單">
        <div class="row" gutter="20">
          <el-button v-if="previewURL" @click="dialogVisible = true" type="text"
            >點選預覽</el-button
          >
          <div v-else class="color-danger">尚未上傳</div>
        </div>
      </el-form-item>
    </el-form>
    <div>
      *空白 DFC 挑戰學習單請
      <a
        href="https://docs.google.com/document/d/18B5tbbRo7K79_k-7fUIcNEjO2quGi3uIeaAnpr6DEF8/edit?usp=sharing"
        target="_blank"
        class="color-blue1"
        >由此</a
      >
      下載
    </div>
    <div>
      DFC 挑戰學習單（範例），請
      <a
        href="https://drive.google.com/drive/folders/1d4mwWQKB4SqkA6NjzPXNXbJarFwuCRmX?usp=sharing"
        target="_blank"
        class="color-blue1"
        >由此</a
      >
      下載
    </div>
    <div>
      DFC 挑戰學習單 填寫引導手冊，請
      <a
        href="https://drive.google.com/file/d/1gf1Con5wNsXkTiq1TfE4z72tZOnKHCk4/view?usp=sharing"
        target="_blank"
        class="color-blue1"
        >由此</a
      >
      下載
    </div>
    <div>
      *請上傳 PDF 檔案，可以看到
      <a
        href="https://sofree.cc/word-convert-pdf/"
        target="_blank"
        class="color-blue1"
        >如何將Word檔案另存成PDF檔</a
      >
    </div>
    <b
      >此份 DFC 挑戰學習單以及 DFC 挑戰引導手冊之版權為社團法人臺灣童心創意行動協會所有，請勿侵權及改作，翻印必究。</b
    >
    <el-dialog :visible.sync="dialogVisible">
      <iframe
        :src="previewURL"
        frameborder="0"
        width="100%"
        height="500px"
      ></iframe>
    </el-dialog>
  </brows-layout>
</template>

<script>
import { mapState } from "vuex";
import BrowsLayout from "./BrowsLayout.vue";

export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  computed: {
    ...mapState("story", ["editStoryData"]),
    previewURL() {
      return this.editStoryData.pdf_list &&
        this.editStoryData.pdf_list.length > 0
        ? this.editStoryData.pdf_list[0].url
        : "";
    },
  },
  methods: {
    transformStoryAccount(val) {
      return val;
      // return val && val.match(/[0-9]+/)[0] || "";
    },
  },
  created() {},
  mounted() {},
  components: {
    BrowsLayout,
  },
};
</script>

<style lang="scss" scoped>
.pdf {
  font-size: 14px;

  .tips {
    font-size: 12px;
  }
}
</style>
